import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";function ownKeys(object, enumerableOnly) {var keys = _Object$keys(object);if (_Object$getOwnPropertySymbols) {var symbols = _Object$getOwnPropertySymbols(object);enumerableOnly && (symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {return _Object$getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function _objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {_defineProperty(target, key, source[key]);}) : _Object$getOwnPropertyDescriptors ? Object.defineProperties(target, _Object$getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));});}return target;}import _replaceAllInstanceProperty from "@babel/runtime-corejs3/core-js/instance/replace-all";import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";import _Object$assign from "@babel/runtime-corejs3/core-js-stable/object/assign";import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import colors from "../../utils/colors";
import { CloudUpload, Delete, DriveFile, NavigationClose } from "../../icons";
import Button from "../Button";

import {
baseStyle,
activeStyle,
acceptStyle,
rejectStyle,
acceptedFileItem,
removeFileButton,
filesListTitle,
errorMessage,
fileNameStyle,
acceptedFilesWrapper,
filesList,
rejectedFilesWrapper } from "./styles";


export var UPLOAD_FILE_TYPES = {
  csv: 'text/csv',
  pdf: 'application/pdf',
  xls: 'application/vnd.ms-excel',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  tsv: 'text/tab-separated-values',
  psv: 'text/pipe-separated-values'
};

var FileUpload = function FileUpload(props) {var _context3;
  var
    onChange =




    props.onChange,shouldBeReset = props.shouldBeReset,fileMimeTypes = props.fileMimeTypes,messageForRejectedFiles = props.messageForRejectedFiles,_props$allowMultipleF = props.allowMultipleFiles,allowMultipleFiles = _props$allowMultipleF === void 0 ? true : _props$allowMultipleF;
  var _useState = useState({}),_useState2 = _slicedToArray(_useState, 2),files = _useState2[0],setFiles = _useState2[1];
  var _useState3 = useState(false),_useState4 = _slicedToArray(_useState3, 2),quantityError = _useState4[0],setQuantityError = _useState4[1];

  var defaultFileMimeTypes = [UPLOAD_FILE_TYPES.xls, UPLOAD_FILE_TYPES.xlsx];

  useEffect(function () {
    onChange(files);
  }, [files]);

  useEffect(function () {
    if (shouldBeReset) {
      setFiles({});
      setQuantityError(false);
    }
  }, [shouldBeReset]);

  var onDrop = useCallback(function (acceptedFiles, fileRejections) {
    if (fileRejections.length > 0) {
      var showQuantityError = fileRejections.some(function (_ref) {var errors = _ref.errors;return (
          errors.some(function (_ref2) {var code = _ref2.code;return code === 'too-many-files';}));});

      setQuantityError(showQuantityError);
    }

    setFiles(function (prevFiles) {return (
        acceptedFiles.reduce(function (acc, file) {var _context, _context2;
          // You cannot directly modify the fields of the File object, as they are read-only.
          // So a new file is created with converted name
          var convertedName = _replaceAllInstanceProperty(_context = _replaceAllInstanceProperty(_context2 = file.name).call(_context2, '&', '_')).call(_context, '+', '_');
          var updatedFile = new File([file], convertedName);

          return allowMultipleFiles ? _objectSpread(_objectSpread({},

          acc), {}, _defineProperty({},
          convertedName, {
            file: updatedFile
          })) : _defineProperty({},


          convertedName, {
            file: updatedFile
          });

        }, prevFiles));});

  }, []);

  var _useDropzone =






    useDropzone({
      onDrop: onDrop,
      // File MIME types -> default types for .xls and .xlsx
      accept: fileMimeTypes ? fileMimeTypes.join(',') : defaultFileMimeTypes.join(','),
      multiple: allowMultipleFiles
    }),isDragActive = _useDropzone.isDragActive,isDragAccept = _useDropzone.isDragAccept,isDragReject = _useDropzone.isDragReject,fileRejections = _useDropzone.fileRejections,getRootProps = _useDropzone.getRootProps,getInputProps = _useDropzone.getInputProps;

  var style = useMemo(
  function () {return _objectSpread(_objectSpread(_objectSpread(_objectSpread({},
    baseStyle),
    isDragActive ? activeStyle : {}),
    isDragAccept ? acceptStyle : {}),
    isDragReject ? rejectStyle : {});},

  [isDragActive, isDragReject, isDragAccept]);


  var acceptedFileItems = _mapInstanceProperty(_context3 = _Object$keys(files)).call(_context3, function (fileName) {
    var currentFile = files[fileName].file;

    var removeAcceptedFileByName = function removeAcceptedFileByName() {
      setFiles(function (prevFiles) {
        var newObj = _Object$assign(prevFiles);
        delete newObj[fileName];
        var resultObj = {};

        // eslint-disable-next-line no-restricted-syntax
        for (var key in newObj) {
          if (newObj[key]) {
            resultObj[key] = newObj[key];
          }
        }
        return resultObj;
      });
    };
    return (
      (currentFile === null || currentFile === void 0 ? void 0 : currentFile.name) && /*#__PURE__*/
      React.createElement("li", { style: acceptedFileItem, key: currentFile.name }, /*#__PURE__*/
      React.createElement(DriveFile, { width: "2rem", height: "2rem", color: colors.green[600] }), /*#__PURE__*/
      React.createElement("p", { style: fileNameStyle }, currentFile.name), /*#__PURE__*/
      React.createElement("div", { style: removeFileButton }, /*#__PURE__*/
      React.createElement(Button, {
        type: "icon",
        onClick: function onClick() {
          removeAcceptedFileByName();
        } }, /*#__PURE__*/

      React.createElement(Delete, { width: "2rem", height: "2rem", color: colors.red[500] })))));





  });

  var rejectedFileItems = _mapInstanceProperty(fileRejections).call(fileRejections, function (_ref4) {var file = _ref4.file;
    return /*#__PURE__*/(
      React.createElement("li", { style: acceptedFileItem, key: file === null || file === void 0 ? void 0 : file.name }, /*#__PURE__*/
      React.createElement(NavigationClose, { width: "2rem", height: "2rem", color: colors.red[600] }), /*#__PURE__*/
      React.createElement("p", { style: fileNameStyle }, " ", file === null || file === void 0 ? void 0 : file.name)));


  });

  return /*#__PURE__*/(
    React.createElement("section", null, /*#__PURE__*/
    React.createElement("div", getRootProps({ style: style }), /*#__PURE__*/
    React.createElement("input", getInputProps()), /*#__PURE__*/
    React.createElement(CloudUpload, { width: "6rem", height: "6rem", color: colors.neutral[800] }), /*#__PURE__*/
    React.createElement("div", null,
    isDragAccept && /*#__PURE__*/React.createElement("p", null, "Your files will be accepted"),
    isDragReject && /*#__PURE__*/
    React.createElement("p", null, messageForRejectedFiles || 'Please drop only .xls or .xlsx files'),

    !isDragActive && /*#__PURE__*/
    React.createElement("p", null, "Browse your files or ", /*#__PURE__*/
    React.createElement("br", null), " drag and drop here to upload")), /*#__PURE__*/



    React.createElement(Button, { size: "large", color: "primary" }, "Click to import")),



    _Object$keys(files).length > 0 && /*#__PURE__*/
    React.createElement("div", { style: acceptedFilesWrapper }, /*#__PURE__*/
    React.createElement("h3", { style: filesListTitle }, "Accepted Files"), /*#__PURE__*/
    React.createElement("ul", { style: filesList }, acceptedFileItems)),


    fileRejections.length > 0 && /*#__PURE__*/
    React.createElement("div", { style: rejectedFilesWrapper }, /*#__PURE__*/
    React.createElement("h3", { style: filesListTitle }, "Rejected Files"), /*#__PURE__*/
    React.createElement("p", { style: errorMessage },
    quantityError ?
    'You can upload only one file.' :
    messageForRejectedFiles || 'Please drop only .xls or .xlsx files'), /*#__PURE__*/

    React.createElement("ul", { style: filesList }, rejectedFileItems))));




};

export default FileUpload;
//# sourceMappingURL=index.js.map